"use client";

import SeriesCard from "@/components/series-card";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    type CarouselApi,
} from "@/components/shadcn/carousel";
import type { SeriesWithVideoTrainer } from "@/types";
import { useEffect, useState } from "react";

export default function SeriesWidgetCarousel({
    series,
    itemKeyPrefix,
}: {
    series: SeriesWithVideoTrainer[];
    itemKeyPrefix: string;
}) {
    const [api, setApi] = useState<CarouselApi>();
    // How many cards fit depends on the breakpoint (one below `sm`, two above),
    // so ask embla whether anything is actually off-screen instead of guessing
    // from the item count. `reInit` fires on resize, keeping this in sync.
    const [hasOverflow, setHasOverflow] = useState(false);

    useEffect(() => {
        if (!api) return;
        const update = () =>
            setHasOverflow(api.canScrollPrev() || api.canScrollNext());
        update();
        api.on("reInit", update).on("select", update);
        return () => {
            api.off("reInit", update).off("select", update);
        };
    }, [api]);

    return (
        <Carousel opts={{ align: "start" }} setApi={setApi} className="w-full">
            <CarouselContent>
                {series.map((item) => (
                    <CarouselItem
                        key={`${itemKeyPrefix}-${item.Id}`}
                        className="sm:basis-1/2"
                    >
                        <SeriesCard series={item} variant="training" />
                    </CarouselItem>
                ))}
            </CarouselContent>
            {hasOverflow && (
                <>
                    <CarouselPrevious
                        variant="default"
                        className="-left-3 rounded-md"
                    />
                    <CarouselNext
                        variant="default"
                        className="-right-3 rounded-md"
                    />
                </>
            )}
        </Carousel>
    );
}
